var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-6"},[_c('h2',{staticClass:"pt-5 pb-5"},[_vm._v("Medical History ")]),_c('PatientInformationForm'),_vm._v(" "+_vm._s(_vm.patientInformation)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }